export const container = `flex flex-col mb-2`;
export const title = `group-data-[is-expanded=false]/sidebar:invisible`;
